import { AddOutlined, SearchOff } from "@mui/icons-material";
import Flx from "../../components/layout/Flx";
import Screen from "../../components/layout/Screen";
import ScreenContent from "../../components/layout/ScreenContent";
import TitledHeader from "../../components/layout/TitledHeader";
import Txt from "../../components/typography/Txt";
import Htag from "../../components/typography/Htag";
import { grey } from "@mui/material/colors";
import { Box, Button } from "@mui/material";
import { Navigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { useMemo } from "react";

const ClosedLoansScreen = () => {
  const closedLoans = useMemo(() => {
    return [];
  }, []);
  return (
    <Screen
      sx={{
        position: "absolute",
        left: 0,
        width: "100%",
        backgroundColor: "#f5f8fa",
        height: "100%",
      }}
    >
      <TitledHeader
        title={"Closed Loans"}
        description="Loans that have been fully funded and closed."
      />
      <ScreenContent
        maxWidth={isEmpty(closedLoans) ? "md" : "xl"}
        sx={{
          width: "100%",
          pb: 14,
          pt: 4,
          // px: isMobile ? 0 : 5,
          margin: "0px auto",
        }}
      >
        {
          isEmpty(closedLoans) ? (
            <Box
              sx={{
                my: 2,
                p: 1,
                py: 5,
                border: "1px solid #e2e8f0",
                borderRadius: 2,
                background: "#ffffff",
              }}
            >
              <Flx
                column
                gap={1}
                sx={{ maxWidth: "620px", margin: "0 auto" }}
                center
              >
                <SearchOff
                  className="thin"
                  sx={{ mb: 2, fontSize: 54, color: grey[400] }}
                />
                <Htag h3>No Closed Loans Found</Htag>
                <Txt secondary center>
                  There are no closed loans available at the moment. Talk to
                  your loan officer for more information about your loan history
                  and any closed loans.
                </Txt>
                <Button
                  sx={{ mt: 2 }}
                  size="large"
                  startIcon={<AddOutlined />}
                  onClick={() => Navigate("/financing-request/create")}
                >
                  Create New Financing Request
                </Button>
              </Flx>
            </Box>
          ) : null
          // <Flx column g={0.4}>
          //   <Flx column g={0.4} sx={{ mb: 1 }}>
          //     <Txt sx={{ fontWeight: 400, fontSize: 14 }} secondary>
          //       You have <b>{size(stagedApplications)}</b> staged application
          //       {size(stagedApplications) > 1 ? "s" : ""} waiting for your
          //       review.
          //     </Txt>

          //   </Flx>
          //   <StagedApplicationsTable
          //     rowData={stagedApplications}
          //     onRowClicked={(application) =>
          //       setSelectedApplication(application)
          //     }
          //   />
          // </Flx>
        }
      </ScreenContent>
    </Screen>
  );
};
// if (isEmpty(financingRequests)) {
//   return (
//     <Card sx={{ py: 6, px: 4 }}>
//       <Flx g={1} center fw column>
//         <AddBusinessOutlined sx={{ fontSize: "36px " }} className="thin" />
//         <Txt bold center>
//           No Applications Yet
//         </Txt>
//         <Txt secondary center>
//           Ready to get started? Create your first loan application to begin
//           the process.
//         </Txt>
//         <Button
//           sx={{ mt: 2 }}
//           onClick={() => navigate("/financing-request/create")}
//         >
//           Start a New Financing Request
//         </Button>
//       </Flx>
//     </Card>
//   );
// }
export default ClosedLoansScreen;
